import React from 'react';

// Components
import { SidePanelFooter } from 'Components/SidePanel';
import { Button } from 'Components';
import RadioGroup, { RadioCheck } from 'Components/RadioGroup';
import { useDispatch, useSelector } from 'react-redux';
// Actions
import { drawGetDirections, clearLayers, addPointers } from 'Redux/actions'
import { TypeObjectMap } from '../../../../../../../components/Map/providers/enums';

// Styles
import './styles.scss'

const NewLayer = (props) => {
  const {
    messages,
    layerType,
    setLayerType,
    handleView,
    onShowMapSettings,
    errorType,
    mapRef
  } = props;

  const dispatch = useDispatch();

  const vehicleTrailsLayer = useSelector(state => state.realtimeMapLayerMapModuleRedux.vehicleTrailsLayer);
  const routes = useSelector(state => state.realtimeMapLayerMapModuleRedux.routes);
  const validateButton = vehicleTrailsLayer.length > 0 || routes.length > 0
  
  return (
    <div className="layers-container">
      <div className="form-item">
        <label className="input-normal-label">{`${messages['realtimemaps_layer_map_select_layer_type']}:`}<span className="text-danger"> *</span></label>
        <div>
          <RadioGroup id="containerRoute" value={layerType} onChange={() => setLayerType('route')} required vertical >
            <RadioCheck id="route" value="route" label={`${messages['realtimemaps_layer_map_route']}`} size='md' />
          </RadioGroup>
          <p className="layer-description">{messages['realtimemaps_layer_map_description_route']}</p>
        </div>
        <div>
          <RadioGroup id="containerTrail" value={layerType} onChange={() => setLayerType('vehicleTrail')} required vertical >
            <RadioCheck id="vehicleTrail" value="vehicleTrail" label={`${messages['realtimemaps_layer_map_vehicle_trail']}`} size='md' />
          </RadioGroup>
          <p className="layer-description">{messages['realtimemaps_layer_map_description_vehicle_trail']}</p>
        </div>
        <div>
          <RadioGroup id="containerLayerKmz" value={layerType} onChange={() => setLayerType('layerKmz')} required vertical >
            <RadioCheck id="layerKmz" value="layerKmz" label={`${messages['realtimemaps_layer_map_using_layer_kmz']}`} size='md' />
          </RadioGroup>
          <p className="layer-description">{messages['realtimemaps_layer_map_description_layer_kmz']}</p>
        </div>
        {errorType && <small className="text-danger">{messages['required_field']}</small>}
        {validateButton && (
          <div style={{ marginTop: 20, width: '100%' }}>
            <Button
              className='layer-button'
              onClick={() => {
                dispatch(addPointers([]));
                dispatch(drawGetDirections(false));
                dispatch(clearLayers());
                mapRef?.current?.showUnitsByPreferences();

                if(routes && routes?.length){
                  routes.forEach(element => {
                    mapRef?.current?.removeMapObject(`layerRoute_${element.id}`, TypeObjectMap.Routes );
                  });
                }
              }}
            >
              {`${messages['realtimemaps_layer_map_remove_layer']}*`}
            </Button>
          </div>
        )}
        <SidePanelFooter>
          <Button
            className='btn-cancel'
            onClick={() => {
              onShowMapSettings();
            }}
          >
            {messages['realtimemaps_layer_map_cancel']}
          </Button>
          <Button
            className='btn-blue'
            onClick={() => handleView()}
          >
            {messages['realtimemaps_layer_map_next']}
          </Button>
        </SidePanelFooter>
      </div>
    </div>
  )
}

export default NewLayer;